import { useEffect, useState } from "react";
import { BasicButton } from "../../theme/Component/BasicButton";
import { FileInput } from "../../theme/Component/FileInput";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _Inbox, _ProcedureImp, _single } from "../../../core/services/dataBean/EntityCatalog";
import { FileService } from "../../../core/services/FileService";
import { toast } from "react-toastify";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Props {
    action: any;
    exportMap: any;
}
export const RenderDocumentTRD = ({ action, exportMap }: Props) => {

    const { instance } = useDataBean(_ProcedureImp);
    const _bandeja = useDataBean(_Inbox)

    const fileService = new FileService();

    const [doc, setDoc] = useState<any>({});
    const [document, setDocument] = useState<any>({});
    const [conf, setConf] = useState<any>({});
    const [plantilla, setPlantilla] = useState<any>({});
    const [noTemplate, setNotTemplate] = useState<boolean>(false);
    const [listDocument, setListDocument] = useState<any>([]);

    useEffect(() => {


        let Document = undefined;
        try {
            Document = JSON.parse(action.Description);
            setConf(Document);
        } catch (error) {

        }

        if (Document) {

            instance.getHiringModalityDocument(Document.IDDocument).then(
                (resp: any) => {
                    setDocument(resp);
                    if (resp.JsonMedia) {
                        setPlantilla(JSON.parse(resp.JsonMedia) ?? "{}");
                    }
                }
            )
        } else {
            setNotTemplate(true);
        }
    }, [action])

    useEffect(() => {
        if (doc.Media) {
            setDocument({ ...document, ...doc });
        }

    }, [doc])

    const updateDoc = async () => {
        if (listDocument.length === 0) return;

        for (const doc of listDocument) {
            await pushResumeInfo(doc);
        }

        console.log("Todos los documentos han sido procesados. Ejecutando exportMap...");
        exportMap(
            {
                MediaContext: "Documen",
                Media: JSON.stringify(listDocument)
            }
        )
    };
    const updateDocOmit = async () => {
        

        console.log("Todos los documentos han sido procesados. Ejecutando exportMap...");
        exportMap(
            {
                MediaContext: "Documen",
                Media: JSON.stringify([])
            }
        )
    };

    const pushResumeInfo = (objeto: any) => {
        _bandeja.instance.pushResumeBpm(action.IDProcedureImp, _single.getAccountID(), `Se cargo el documento ${objeto.UploadName}(${objeto.Name}) en el paso: ${action.ProcedureActionName}`, { disableSpinner: true }).then((resp) => {
            console.log(resp)
        }).catch(err => { console.log("Error en actualizar la tabla", err) })
    }

    const updateDocList = (media: string, mediaContext: string, uploadeName: string, typeName: string) => {
        let data = {
            DataBeanProperties: { ...document, Media: media, MediaContext: mediaContext },
            DataBeanName: "com.orange.bean.supplier.HiringModalityDocument"
        }
        instance.putDocumentTRD(action.IDProcedureImp, _single.getAccountID(), data).then(
            (resp: any) => {
                let ll = [...listDocument];
                ll.push({ ...resp, UploadName: uploadeName, TypeName: typeName });
                console.log(ll);

                setListDocument(ll);
            }
        )
    }

    const deleteDocument = (recorDocumentID: number) => {
        instance.deleteDocumentTRD(recorDocumentID, _single.getAccountID()).then(
            (resp) => {
                console.log(resp.IDRecordDocumentTRD)
                setListDocument((prevLista) => prevLista.filter((objeto) => objeto.IDRecordDocumentTRD !== recorDocumentID));
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("Error al realizar la acción")
            }
        )
    }

    return (
        <div className="row">
            {/* <PrintJson json={action} /> */}
            <div className="col-md-12">
                <p>
                    {action.Name} <br /><small>({document.LegalRequirementTypeName ?? "Documento sin Requerimiento Legal"})</small>
                </p>
            </div>
            <div className="col-md-6">
                <FileInput
                    disable={(listDocument.length > 0 && conf.Multiple === false)}
                    docAcept="application/pdf"
                    Media={doc.Media}
                    MediaContext={doc.MediaContext}
                    directory="trdDocument"
                    onCreate={(e: any) => { updateDocList(e.Media, e.MediaContext, e.Name, e.TypeName) }}
                ></FileInput>
            </div>
            <div className="col-md-6 align-content-end">
                {document.IDHiringModalityDocument &&
                    <p>
                        <strong>Documento </strong> <small>{document.Name}</small> <br />
                        <strong>Descripción </strong> <small>{document.Description}</small><br />
                    </p>
                }
                {plantilla?.Media &&
                    <p>
                        <a href={`${fileService.getUrlFile(plantilla.mediaContext, plantilla.media)}`}>Descargar Plantilla</a>
                    </p>

                }
            </div>
            <div className="col-md-12">
                <div className="row ">
                    {listDocument.length === 0 ? (
                        <></>
                    ) : (
                        <>
                            <hr className="mt-2" />
                            <label>Documentos cargados</label>
                            <div className="list-group " style={{ maxHeight: "52vh", overflow: "auto" }}>
                                {listDocument.map((item: any, index: number) => (
                                    <div key={index} className="list-group-item d-flex justify-content-between align-items-center" >
                                        <span style={{ width: "80%", overflow: "hidden", textWrap: "nowrap" }}>
                                            <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                            {index + 1} - {item.UploadName ?? item.Name}
                                        </span>
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => { deleteDocument(item.IDRecordDocumentTRD) }}
                                        >
                                            <i className="ri-close-line"></i>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className="col-md-12 mt-3">
                <BasicButton disable={!(listDocument.length > 0)} icon="ri-cloud-line" clase='primary' useMargin eventClick={() => updateDoc()}>Cargar</BasicButton>
                {action.IsOptional === true &&
                <BasicButton clase="warning" icon="ri-cloud-off-line" eventClick={updateDocOmit} useMargin>Omitir</BasicButton>
                }
            </div>
        </div>
    )
}